import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Cookies from 'universal-cookie';
import _ from 'lodash';
import moment from 'moment';

import * as DataAPI from "../common/DataAPI.js";
import * as history from '../common/history.js';
import * as constants from '../common/constants.js';
import Dialogs from "../common/Dialogs.js";

const cookies = new Cookies();

class Login extends Component {
  constructor(props) {
    super();

    const query = _.split(_.replace(_.get(props, 'location.search'), '?', ''), '&');

    let isSupervisor = 'N';
    _.forEach(query, item => {
      if (_.startsWith(item, 'supervisor')) {
        isSupervisor = _.last(_.split(item, '='));
      }
    });

    this.state = {
      userId: cookies.get('_id'),
      canLoginKeypad: cookies.get('canLoginKeypad'),
      canLoginSupervisorKeypad: cookies.get('canLoginSupervisorKeypad'),
      loginId: '',
      password: '',
      isLoginSupervisorKeypad: isSupervisor === 'Y', // http://url?supervisor=Y
    };

    this.updateLoginState = this.updateLoginState.bind(this);
    this.login = this.login.bind(this);
  }

  componentWillMount() {
    if (this.state.userId) {
      if ((this.state.isLoginSupervisorKeypad && this.state.canLoginSupervisorKeypad === 'true')
        || (!this.state.isLoginSupervisorKeypad && this.state.canLoginKeypad === 'true')) {
        this.navigateToKeypadPage();
      }
    }
  }

  navigateToKeypadPage() {
    history.push(`/keypad${this.state.isLoginSupervisorKeypad ? '?supervisor=Y' : ''}`);
  }

  updateLoginState(event) {
    const fieldName = event.target.name;
    const value = event.target.value;
    this.setState({ [fieldName]: value });
  }

  login(event) {
    event.preventDefault();

    DataAPI.post('/api/keypad/login', {
      loginId: this.state.loginId,
      password: this.state.password,
      isLoginSupervisorKeypad: this.state.isLoginSupervisorKeypad,
    }, (err, res) => {
      if (err || !res.userId) return this.dialogs.error(err);

      cookies.set('_id', res.userId, constants.keypadLoginRequired ? { expires: moment().endOf('day').toDate() } : {});
      cookies.set('loginId', this.state.loginId, {});
      cookies.set('canLoginKeypad', res.canLoginKeypad, { expires: moment().endOf('day').toDate() });
      cookies.set('canLoginSupervisorKeypad', res.canLoginSupervisorKeypad, { expires: moment().endOf('day').toDate() });

      this.navigateToKeypadPage();
    });
  }

  render() {
    return (
      <div className="keypad-login-block">
        <Grid className="login-block">
          <Row center="xs">
            <Col className="login-form">
              <form onSubmit={this.login}>
                <div className="title">智能排隊系統</div>
                <div className="content">
                  <div>
                    <TextField
                      name="loginId"
                      floatingLabelText="ID"
                      value={this.state.loginId}
                      onChange={this.updateLoginState}
                    />
                  </div>
                  <div>
                    <TextField
                      name="password"
                      type="password"
                      floatingLabelText="密碼"
                      value={this.state.password}
                      onChange={this.updateLoginState}
                    />
                  </div>
                  <br />
                  <RaisedButton type="submit" label="登入" primary={true} fullWidth={true} />
                </div>
              </form>
            </Col>
          </Row>
        </Grid>
        <Dialogs onInit={dialog => (this.dialogs = dialog)} />
      </div>
    )
  }
}

export default Login;


// WEBPACK FOOTER //
// client/keypad/KeypadLogin.js